import { render, staticRenderFns } from "./DeliveryTable.vue?vue&type=template&id=dac414ee&scoped=true&"
import script from "./DeliveryTable.vue?vue&type=script&lang=js&"
export * from "./DeliveryTable.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryTable.vue?vue&type=style&index=0&id=dac414ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac414ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
